const empty = () =>
  import(/* webpackChunkName: "empty" */ "../views/Empty.vue");
export default [
  {
    path: "user",
    name: "User",
    component: empty,
    children: [
      {
        path: "user",
        name: "UserManage",
        component: empty,
        children: [
          {
            path: "student",
            name: "Student",
            component: () =>
              import(/* webpackChunkName: "user" */ "../views/user/Student"),
            meta: {
              title: "学员管理",
              root: true,
            },
          },
          {
            path: "student-edit",
            name: "StudentEdit",
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/StudentEdit"
              ),
            meta: {
              title: "新增/编辑学员",
            },
          },
          {
            path: "student-imports",
            name: "StudentImports",
            component: () =>
              import(/* webpackChunkName: "user" */ "../views/Imports"),
            meta: {
              title: "批量导入",
            },
          },
          {
            path: "student-exports",
            name: "StudentExports",
            component: () =>
              import(/* webpackChunkName: "user" */ "../views/Exports"),
            meta: {
              title: "查看报表",
            },
          },
          {
            path: "teacher",
            name: "Teacher",
            component: () =>
              import(/* webpackChunkName: "user" */ "../views/user/Teacher"),
            meta: {
              title: "讲师管理",
              root: true,
            },
          },
          {
            path: "teacher-edit",
            name: "TeacherEdit",
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/TeacherEdit"
              ),
            meta: {
              title: "新增/编辑讲师",
            },
          },
          {
            path: "teacher-imports",
            name: "TeacherImports",
            component: () =>
              import(/* webpackChunkName: "user" */ "../views/Imports"),
            meta: {
              title: "批量导入",
            },
          },
          {
            path: "teacher-exports",
            name: "TeacherExports",
            component: () =>
              import(/* webpackChunkName: "user" */ "../views/Exports"),
            meta: {
              title: "查看报表",
            },
          },
          {
            path: "teacher-detail",
            name: "TeacherDetail",
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/TeacherDetail"
              ),
            meta: {
              title: "讲师详情",
            },
          },
          {
            path: "assist",
            name: "AssistTeacher",
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/AssistTeacher"
              ),
            meta: {
              title: "助教管理",
              root: true,
            },
          },
          {
            path: "assist/edit",
            name: "AssistTeacherEdit",
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/AssistTeacherEdit"
              ),
            meta: {
              title: "新增/编辑助教",
            },
          },
          {
            path: "assist/detail",
            name: "AssistTeacherDetail",
            component: () =>
              import(
                /* webpackChunkName: "user" */ "../views/user/AssistTeacherDetail"
              ),
            meta: {
              title: "助教详情",
            },
          },
          {
            path: "assist/export",
            name: "AssistTeacherExport",
            component: () =>
              import(/* webpackChunkName: "user" */ "../views/Exports"),
            meta: {
              title: "查看报表",
            },
          },
          {
            path: "assist/import",
            name: "AssistTeacherImport",
            component: () =>
              import(/* webpackChunkName: "user" */ "../views/Imports"),
            meta: {
              title: "批量导入",
            },
          },
          {
            path: "assist/students",
            name: "AssistStudentList",
            component: () =>
              import(
                /* webpackChunkName: "teach" */ "../views/teach/StudentList.vue"
              ),
            meta: {
              title: "学员列表",
            },
          },
          {
            path: "assist/homework",
            name: "AssistHomeworkList",
            component: () =>
              import(
                /* webpackChunkName: "teach" */ "../views/teach/HomeworkList.vue"
              ),
            meta: {
              title: "作业列表",
            },
          },
        ],
      },
    ],
  },
];
